import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { MisVisitasContent } from './components/MisVisitasContent';

export default function MisVisitas() {
    return (
        <MainContent
            component={<MisVisitasContent />}
            titulo="Mis Visitas"
            noBackground
            tableMaxWidth
        />
    );

};
